var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { createContext, useContext } from 'react';
var initialValue = {
    disabled: false,
    hidden: false,
    hideLoadingState: false
};
var FormGroupContext = createContext(initialValue);
export var FormGroupContextProvider = function (_a) {
    var value = _a.value, children = _a.children;
    var parentContext = useContext(FormGroupContext);
    return (React.createElement(FormGroupContext.Provider, { value: __assign(__assign({}, parentContext), value) }, children));
};
export var useFormGroupContext = function () {
    return useContext(FormGroupContext);
};
//# sourceMappingURL=FormGroupContext.js.map